<template>
  <div class="modal-overlay" v-if="visible" @click.self="$emit('cancel')">
    <div class="modal-card confirm-dialog">
      <h2 class="modal-title">{{ title }}</h2>
      <p class="confirm-message">{{ message }}</p>
      <div class="modal-actions">
        <button class="btn-secondary" @click="$emit('cancel')">Cancelar</button>
        <button :class="variant === 'danger' ? 'btn-danger' : 'btn-primary'" @click="$emit('confirm')">
          {{ confirmLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: 'Confirmar' },
    message: { type: String, default: 'Tem certeza?' },
    confirmLabel: { type: String, default: 'Confirmar' },
    variant: { type: String, default: 'danger' }
  },
  emits: ['confirm', 'cancel']
}
</script>

<style scoped>
.confirm-dialog {
  max-width: 400px;
  text-align: center;
}
.confirm-message {
  color: var(--color-text-secondary);
  font-size: var(--text-base);
  margin-bottom: var(--spacing-base);
}
.modal-actions {
  justify-content: center;
}
</style>
